// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-2K8DBPG5QS","main":"main-1jtNZjI1v1"};